export class ExcelUploadResponse {
     MandatoryColumns: String;
     ActualColumns: String;
     TicketTypes_AO: { TicketType: string, TicketTypeId: number }[];
     TicketTypes_IO: { TicketType: string, TicketTypeId: number }[];
     DisplayResolutionDesc: boolean;
     DisplayLongDesc : boolean;
     BAUploadedData: Uint8Array;
     ExcelMappingFields: { MappingField: string, ActualField: string, MappingIndex: number, IsCustomField: boolean }[];
     CategorisedBy: { name: string }[];
     ClassifiedBy: { name: string }[];
     CategorisedByDD: any;
     HistoricalDomainMapping: any;
     MinTicketDate: Date;
     MaxTicketDate: Date;
     MappingData_AO: { FilterName: string, ActualFilterName: string, data: { name: string, indexNo: number,isChecked: boolean } [] };
     MappingData_IO: { FilterName: string, ActualFilterName: string, data: { name: string, indexNo: number, isChecked: boolean }[] };
     MappingData_Others: { FilterName: string, ActualFilterName: string, data: { name: string, indexNo: number, isChecked: boolean }[] };
     WordCloudFilterOptions: string;
     fileName: string;
     SheetName: string;     
}

export class DomainMappingRequest {
     ProposalId: string;
     ClientId: string;
     MappingField: string;
     MappingData_AO: { name: string, indexNo: number, isChecked: boolean }[];
     MappingData_IO: { name: string, indexNo: number, isChecked: boolean }[];
     MappingData_Others: { name: string, indexNo: number, isChecked: boolean }[];
     UserId: string;
     UserType: number;
}